import React, { useEffect, useState } from "react";
import AddChallengeButton from "./components/AddChallengeButton";
import { toast } from "react-toastify";
import editIcon from "../../assets/images/icons/edit-sm-blue.png";

import { deleteChallengesById, getChallenges, updatestatusChallengesById, uploadChallanges } from "../../api/challenge/index";
import ActionButton from "../../components/common/ActionBtn";
import { PERPAGE_RECORD, showToast } from "../../utils/isValidImage";
import CustomPagination from "../../components/common/CustomPagination";
import { ToogleField } from "../../components/common/Toggle";


const AddChallenge = () => {
  const [currentChallenges, setCurrentChallenges] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [planData, setPlanData] = useState({});
  const [fileName, setFileName] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [currentModal, setCurrentModal] = useState(null);
  const [pagination, setPagination] = useState(null);

  const openModal = (modalNumber) => {
    setCurrentModal(modalNumber);
  };

  const fetchPlans = async (page = 1) => {
    try {
      const data = await getChallenges({ page, limit: PERPAGE_RECORD });
      if (data.pagination) {
        setPagination(data.pagination);
        setCurrentChallenges(data?.data);
      } 
    } catch (error) {
      setErrorMessage("Failed to fetch plans");
      console.error(error);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  const handleEditClick = async (record) => {
    setSelectedPlanId(record?.id);
    setPlanData(record);
    openModal(2);
    // try {
    //   const data = await getRecipeDataById(planId);
    //   setPlanData(data);
    // setFileName(selectedFile.name);
    //   openModal(2);
    // } catch (error) {
    //   setErrorMessage(error.message);
    //   console.error("Failed to load plan:", error.message);
    // }
  };

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileSizeLimit = 50 * 1024 * 1024;
      if (selectedFile.size > fileSizeLimit) {
        setErrorMessage(
          "File size exceeds the 50MB limit. Please upload a smaller file."
        );
        setFileName(null);
        return;
      }

      const validExtensions = ["json"];
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
      if (!validExtensions.includes(fileExtension)) {
        setErrorMessage("Please upload a valid JSON file.");
        setFileName(null);
        return;
      }

      setErrorMessage(null);
      setFileName(selectedFile.name);

      const reader = new FileReader();
      reader.onload = () => {
        try {
          const jsonData = JSON.parse(reader.result);
          setPlanData(jsonData);
        } catch (e) {
          setErrorMessage("The uploaded file is not a valid JSON file.");
          setFileName(null);
        }
      };
      reader.readAsText(selectedFile);
    }
  };

  const handleSubmit = async (formdata) => {
    if (!fileName && !selectedPlanId) {
      showToast("No file selected for upload.", false);
      return;
    }

    try {
      const updatedFile = new File([JSON.stringify(formdata)], fileName, {
        type: "application/json",
      });

      const formDataToUpload = new FormData();
      formDataToUpload.append("file", updatedFile, fileName);

      const response = await uploadChallanges(formDataToUpload, fileName);
      if (response) {
        showToast(
          `Success! Your Chalange has been saved. Refer to the add new Chalange for details.`,
          true
        );

        setFileName(null);
        setPlanData({});
        await fetchPlans();
      }
    } catch (error) {
      showToast("Failed to upload plan.", false);
    }
  };

  

  const toggleStatus = async (plan) => { 
    try {
      const response = await updatestatusChallengesById(plan?.id);
      if (response) {
        showToast(
          `Success! Your Chalange status has been saved.`,
          true
        );
        await fetchPlans();
      }
    } catch (error) {
      showToast("Failed to upload plan.", false);
    }

  }

  const handleAddNewPlanClick = () => {
    setSelectedPlanId(null);
  };

  const handlePageChange = (page) => {
    fetchPlans(page).then();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Chalange?")) {
      try {
        const response = await deleteChallengesById(id);
        if (response.message) {
          toast.success("Chalange deleted successfully!");
          await fetchPlans();
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        toast.error("Failed to delete Chalange.");
        console.error("Error deleting Chalange:", error);
      }
    }
  }

  return (
    <div className="right-side-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6">
            <h2>Chalange Manager</h2>
          </div>
          <div className="col-sm-6">
            <div className="btn-sec">
              <AddChallengeButton
                setCurrentModal={setCurrentModal}
                currentModal={currentModal}
                openModal={openModal}
                modalAddBtn={"Add New Chalanges"}
                selectedPlanId={selectedPlanId}
                handleSubmit={handleSubmit}
                handleFileUpload={handleFileUpload}
                setPlanData={setPlanData}
                planData={planData}
                errorMessage={errorMessage}
                fileName={fileName}
                onAddNewPlanClick={handleAddNewPlanClick}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="table-responsive">
            <table className="table table-hover table-bordered align-middle">
              <thead className="table-light border rounded">
                <tr>
                  <th>S.no</th>
                  <th>Challenge Name</th>
                  <th>Created At</th>
                  <th>Days of Challenge</th>
                  {/* <th>Tasks</th> */}
                  <th>Status</th>
                  <th>Edit</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentChallenges.map((item) => {
                    const statusClass = item.status ? "active-btn" : "inactive-btn";

                  return (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.challenge_name}</td>
                    <td>{new Date(item.created_at).toLocaleString()}</td>
                    <td>{item.days_of_challenge}</td>
                    {/* <td>
                      {item.tasks.map((task, taskIndex) => (
                        <div key={taskIndex}>
                          <strong>{task.task_name}</strong>: {task.count}{" "}
                          {task.unit} ({task.task_type})
                        </div>
                      ))}
                    </td> */}

{/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px",  }}>
            <span
                className={`px-2  rounded-lg text-sm ${statusClass}`}
                style={{ minWidth: "60px", textAlign: "center" }}
            >
                {item.is_active ? "Active" : "Inactive"}
            </span>

            <Switch 
                onChange={() => toggleStatus(item)}
                checked={item.is_active}
                offColor="#ccc"
                onColor="#4CAF50"
                uncheckedIcon={false}
                checkedIcon={false}
                height={20}
                width={40}
            />
            </div>
        </td> */}
                    <ToogleField  toggleStatus={toggleStatus} plan={item} statusClass={statusClass}  />
                    <td>
                      <ActionButton
                        icon={editIcon}
                        onClick={() => handleEditClick(item)}
                        altText="Edit"
                        className="additional-class"
                      />
                    </td>
                    <td>
                       <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => handleDelete(item.id)}
                  >
                    Delete
                  </button>
                    </td>
                  </tr>
                )} )
              }
              </tbody>
            </table>
          </div>

          <CustomPagination
            pagination={pagination}
            handlePageChange={handlePageChange}
          />

         
        </div>
      </div>
    </div>
  );
};

export default AddChallenge;
